import localizationApi from '../../api/localization';

export default {
    namespaced: true,
    state: {
        fetchingTranslations: false,
        translations: null,
        currentLocale: 'nl',
        availableLocales: [],
    },
    mutations: {
        setTranslations(state, translations) {
            state.translations = translations;
        },
        setFetchingTranslations(state, fetching) {
            state.fetchingTranslations = fetching;
        },
        setCurrentLocale(state, locale) {
            state.currentLocale = locale;
        },
        setAvailableLocales(state, locales) {
            state.availableLocales = locales;
        },
    },
    actions: {
        async fetchAvailableLocales({ commit }) {
            try {
                const response = await localizationApi.availableLocales();
                if (response.data.data) {
                    commit('setAvailableLocales', response.data.data);
                }
            } catch (error) {
                console.error('Failed to fetch available locales:', error);
            }
        },
        async changeLocale({ commit }, locale) {
            commit('setFetchingTranslations', true);

            try {
                const translationsResponse = await localizationApi.translations(locale);

                if (!translationsResponse.data.data) {
                    throw new Error('No translations found for locale: ' + locale);
                }

                commit('setTranslations', translationsResponse.data.data);
                commit('setCurrentLocale', locale);
                localStorage.setItem('app_locale', locale);

                return true;
            } catch (error) {
                console.error('Failed to change locale:', error);
                throw error;
            } finally {
                commit('setFetchingTranslations', false);
            }
        },
    },
    getters: {
        getTranslations(state) {
            return state.translations;
        },
        getFetchingTranslations(state) {
            return state.fetchingTranslations;
        },
        getCurrentLocale(state) {
            return state.currentLocale;
        },
        getAvailableLocales(state) {
            return state.availableLocales;
        },
    },
};
